module.exports = __webpack_public_path__ + "static/media/capn6.defa4b49.3gp";